const isDevelopment = process.env.NODE_ENV === "development";

export const logMessage = (message: any, title?: string) => {
  if (isDevelopment) {
    console.log(title, message);
  }
};
